import { render, staticRenderFns } from "./DashboardMultiRadialChart.vue?vue&type=template&id=259e2173&"
import script from "./DashboardMultiRadialChart.vue?vue&type=script&lang=js&"
export * from "./DashboardMultiRadialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports